class Configuration {
  static BASE_URL = process.env.REACT_APP_AUTH_ENDPOINT_URL

  static USER_MANAGEMENT_BASE_URL = process.env.REACT_APP_AUTH_ENDPOINT_URL

  static BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

  static REDIRECT_URL_AFTER_LOGOUT = process.env.REACT_APP_FRONTEND_URL

  static REACT_APP_BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

  static REACT_APP_CORE_BASE_URL = process.env.REACT_APP_CORE_FRONTEND_URL

  static Auth_Endpoints = {
    login: 'auth/login',
    logout: 'auth/invalidate',
    refresh: 'auth/refresh',
    samlLogin: 'auth/discover',
    samlExchange: 'saml/exchange',
    resetPasswordApply: 'users/reset-password/apply',
    sendForgetPasswordEmail: 'auth/reset-password',
    resetPasswordValidate: 'users/reset-password/validation',
    validateToken: 'auth/validate',
    editUser: 'self/users',
    getPolicies: 'company-policies/tenant',
    acceptPolicies: 'company-policies/accept',
  }

  static Company_Endpoints = {
    list: 'companies',
    add: 'companies',
    lookup: 'companies/lookups',
    modules: 'modules',
    lastTenant: 'tenants/last',
    fabsTenants: 'tenants/fabs',
    ssoAddCompanyConfig: (id) => `companies/${id}/saml/config`,
    ssoFetchMetadata: (id) => `companies/${id}/saml/fetch-metadata`,
  }

  static Customer_Admin_Users_Endpoints = {
    list: 'companies/users',
    getUserId: 'companies/users/',
    getCountForAllNonRegisterUsers: 'personnel/employees/users/non-register/count',
    bulkCreateUsers: 'companies/users/bulk',
    bulkCreateUsersValidate: 'companies/batch/process/users/creation/validate',
    bulkCreateUsersProcessValidate: '/companies/batch/process/visibility',
  }

  static User_Batch_Action_Details_Endpoints = (id) => ({
    getStatusDetailsId: `/companies/batch/process/${id}`,
    getStatusDetailsIdUser: `/companies/batch/process/${id}/users`,
  })

  static Companies_Endpoints = {
    companies: 'companies',
  }

  static Titles_Endpoints = {
    titles: 'titles',
  }

  static Employees_Endpoints = {
    employees: 'employees',
  }

  static Departments_Endpoints = {
    departments: 'departments',
  }

  static Roles_Endpoints = {
    systemAdminRoles: 'roles',
    customerAdminRoles: 'companies/roles',
  }

  static Notification_Endpoints = {
    notification: 'notification',
    notificationsBill: 'notifications/bill',
    notificationsSendRegistrationToken: 'notifications/registration/token',
  }

  static Users_Batch_Actions_Status_Endpoints = (id) => ({
    Batch_Actions_Status_list: 'companies/batch/process',
    Batch_Actions_Status_ChangeStatusProcess: `companies/batch/process/${id}/waiting/status`,
  })
}

export default Configuration
